import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import BaseHeader from "@/components/Header/BaseHeader";
import { ASSETS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Assets";
import AssetsTable from "@/components/ListTable/AssetsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { ASSETS_METADATA } from "@/entities/assets";
import AssetAddButton from "@/modules/asset/asset-add-button";
import { ListProvider } from "@/modules/list";

const { Content } = Layout;

const Assets = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:assets")} />
      <Content>
        <ListProvider
          endpoint="assets"
          storageKey={STORAGE_KEYS.ASSETS}
          withMetadata={[ASSETS_METADATA.STATISTICS]}
        >
          <WidgetsGrid
            widgets={[
              ASSETS_STATISTICS_WIDGETS.condition_rating,
              ASSETS_STATISTICS_WIDGETS.risk_level,
              ASSETS_STATISTICS_WIDGETS.state,
            ]}
          >
            <AssetsTable
              showAncestorsColumns
              extraActions={<AssetAddButton />}
            />
          </WidgetsGrid>
        </ListProvider>
      </Content>
    </>
  );
};

export default Assets;
